import { render, staticRenderFns } from "./CaseInsights.vue?vue&type=template&id=68a7a2cb&scoped=true"
import script from "./CaseInsights.vue?vue&type=script&lang=ts"
export * from "./CaseInsights.vue?vue&type=script&lang=ts"
import style0 from "./CaseInsights.vue?vue&type=style&index=0&id=68a7a2cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a7a2cb",
  null
  
)

export default component.exports